var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{class:{ [`form-${_vm.type}`]: true, [`input-${_vm.size}`]: true }},[_c('input',_vm._g(_vm._b({},'input',_vm.$props,false),_vm.$listeners)),_c('i',{staticClass:"form-icon"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }